<div class="construction">
    <div>
        <div class="image-container"><img src="./assets/images/construction.webp" alt=""></div>
        <div class="content">
            Under construction
        </div>
    </div>
</div>